import * as React from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CodeIcon from '@mui/icons-material/Code';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Menu, MenuItem, styled, TableCell } from '@mui/material';
import Chip, { ChipStatus } from 'src/frontend-common/components/Chip';
import { App } from 'src/dto/App';
import ButtonComponent from 'src/components/ButtonComponent';
import { formatDistanceToNow } from 'date-fns';
import { isAdmin } from 'src/utils/user';
import { Search } from '@mui/icons-material';
import { selectUser } from 'src/redux/slices/userSlice';
import { useSelector } from 'react-redux';

interface Props {
  app: App;
  onViewSnippet: () => void;
  onEdit: (app: App) => void;
}

const TransparentButton = styled(Button)(() => ({
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

const statusToChipVariant = (active: boolean): ChipStatus => (active ? 'success' : 'disabled');

const getStatusLabel = (active: boolean) => {
  return active ? 'Active' : 'Inactive';
};

export const AppCells: React.FC<Props> = ({ app, onViewSnippet, onEdit }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const user = useSelector(selectUser);

  const isUserAdmin = isAdmin(user);
  const handleOpen = (event: { currentTarget: React.SetStateAction<HTMLElement | null> }) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <TableCell>{app.name}</TableCell>
      <TableCell>{app.app_key}</TableCell>
      <TableCell>{app.js_app_key}</TableCell>
      <TableCell>
        <Chip status={statusToChipVariant(app.active)}>{getStatusLabel(app.active)}</Chip>
      </TableCell>
      {isUserAdmin && (
        <TableCell>
          <Chip status={statusToChipVariant(app.allow_negative_balance)}>{getStatusLabel(app.allow_negative_balance)}</Chip>
        </TableCell>
      )}
      {isUserAdmin && (
        <TableCell>
          <TableCell>{app.max_enrichment_time ? app.max_enrichment_time : '-'}</TableCell>
        </TableCell>
      )}
      <TableCell>{formatDistanceToNow(new Date(app.created_at), { addSuffix: true })}</TableCell>
      <TableCell>
        {isUserAdmin ? (
          <>
            <ButtonComponent icon={<MoreHorizIcon />} buttontype="icon" onClick={handleOpen} />
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              <MenuItem onClick={() => onEdit(app)}>
                <TransparentButton variant="text" color="inherit" startIcon={<EditIcon />} disableRipple>
                  Edit
                </TransparentButton>
              </MenuItem>

              <MenuItem onClick={onViewSnippet}>
                <TransparentButton variant="text" color="inherit" startIcon={<CodeIcon />} disableRipple>
                  JS widget
                </TransparentButton>
              </MenuItem>
            </Menu>
          </>
        ) : (
          <Search onClick={onViewSnippet} style={{ cursor: 'pointer' }} />
        )}
      </TableCell>
    </>
  );
};
